
import {
    Stack
} from '@mui/material';
import { useState } from 'react';
import CaktoApiTableBody from './CaktoApiTableBody';
import CaktoApiTableSearch from './CaktoApiTableSearch';


export default function CaktoApiTable() {
    const [searchTerm, setSearchTerm] = useState('');

    return (
        <Stack gap={2} >
            <CaktoApiTableSearch searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
            <CaktoApiTableBody searchTerm={searchTerm} />
        </Stack>
    )
}